import { InjectionToken } from '@angular/core';

export const API_ENDPOINT = new InjectionToken<string>('API_ENDPOINT', {
  providedIn: 'root',
  factory: () => ''
});
